import { Button, Link } from '@one-thd/sui-atomic-components';
import React, { useEffect } from 'react';
import { FeatureSwitches } from '../../../../constants/feature-switches';
import { DeliveryInstructionsEdit } from '../../../../hooks/delivery-hooks';
import { catchButtonDisplayEvent } from '../../../../utils/edit-delivery-instructions/analytics';
import '../../../../styles/order-details.scss';
export var EditDeliveryInstructions = function (_a) {
    var fulfillmentGroup = _a.fulfillmentGroup, orderDetailsData = _a.orderDetailsData, _b = _a.buttonVariant, buttonVariant = _b === void 0 ? 'seconday' : _b, handleEditDeliveryInstructions = _a.handleEditDeliveryInstructions, customerType = _a.customerType, fulfillmentGroupIndex = _a.fulfillmentGroupIndex;
    useEffect(function () {
        catchButtonDisplayEvent();
    }, []);
    var onClick = function () {
        DeliveryInstructionsEdit(fulfillmentGroup, orderDetailsData, handleEditDeliveryInstructions, customerType, fulfillmentGroupIndex); // will open EditDeliveryInstructionsDrawer
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "card-fix" }, FeatureSwitches.useTrackerAlignedUX ? (React.createElement(Link, { variant: "body-base", onClick: onClick }, "Edit")) : (React.createElement(Button, { variant: buttonVariant, onClick: onClick, "data-testid": "test-edit-delivery-instructions-button" }, "Edit Delivery Instructions")))));
};
